import CampaignIcon from "@mui/icons-material/Campaign";
import CampaignsPage from "./Page";
import permissions from "app/permissions";
import { CAMPAIGNS, CandidateServicePath } from "utils/constants";
import { tenants } from "utils/tenants";

// Single menu entry — the campaign types are tabs inside CampaignsPage
export const resources = {
  isMenu: true,
  icon: <CampaignIcon />,
  name: CandidateServicePath + CAMPAIGNS,
  title: "Кампании за прием",
  tenancies: [tenants.MU],
  custom: <CampaignsPage />,
  permission: permissions.canPreviewCampaigns,
};

export { campaignResources } from "./campaignResources";
